import { Guid } from "@shared/utils/guid.helper";
import { Address } from "../address/address";
import { Alert } from "../alerts/alert";
import { Contact } from "../common/contact";
import { EntityData } from "./entity-data";
import { ExternalEntity } from "../integrations/external-entity";
import { Relationship } from "../relationships/relationship";
import { SecurityHolding } from "../shares/security-holding";
import { Tag } from "../common/tag";
import { User } from "../organisations/user";

export class Entity extends EntityData {
  static readonly $type : string;
  $type: string;
  entityId: string;
  billingContactId: string | null;
  billingContact: Contact | null;
  signingContactId: string | null;
  signingContact: Contact | null;
  referenceNumber: string;
  familyGroup: string;
  tags: Tag[];
  systemTags: Tag[];
  alerts: Alert[];
  holdings: SecurityHolding[] | null;
  securityholders: Relationship[];
  externalEntities: ExternalEntity[];
  accountManagerId: string | null;
  accountManager: User | null;
  partnerManagerId: string | null;
  partnerManager: User | null;
  relationships: Relationship[];

  constructor(entity: Partial<Entity> = {}) {
    super(entity);
    this.$type = (this.constructor as typeof Entity).$type;
    this.name = entity.name ?? '';
    this.$type = (this.constructor as typeof Entity).$type;
    this.entityId = entity.entityId ?? Guid.EmptyGuid;
    this.registeredAddress = entity.registeredAddress ? new Address(entity.registeredAddress) : new Address();
    this.billingContactId = entity.billingContactId ?? null;
    this.billingContact = entity.billingContact ?? null;
    this.signingContactId = entity.signingContactId ?? null;
    this.signingContact = entity.signingContact ?? null;
    this.holdings = entity.holdings ?? null;
    this.referenceNumber = entity.referenceNumber ?? '';
    this.familyGroup = entity.familyGroup ?? '';
    this.tags = entity.tags ?? [];
    this.alerts = entity.alerts ?? [];
    this.systemTags = entity.systemTags ?? [];
    this.securityholders = entity.securityholders ? entity.securityholders.map((holder) => new Relationship(holder)) : [];
    this.externalEntities = entity.externalEntities ?? [];
    this.accountManagerId = entity.accountManagerId ?? null;
    this.accountManager = entity.accountManager ? new User(entity.accountManager) : null;
    this.partnerManagerId = entity.partnerManagerId ?? null;
    this.partnerManager = entity.partnerManager ? new User(entity.partnerManager) : null;
    this.relationships = entity.relationships?.map((r) => new Relationship(r)) ?? [];
  }

  static override prepareToRequest(entity: Entity): Entity {
    return {
      ...entity,
      ...EntityData.prepareToRequest(entity),
      securityholders: entity.securityholders.map(r => Relationship.prepareToRequest(r)) ?? [],
    }
  }
}
